import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./index.css";
import { LocaleProvider } from "./lib/locale";
import { initTelemetry } from "./lib/telemetry";

// Sentry + PostHog. No-ops when the public keys aren't set at build time.
initTelemetry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* LocaleProvider wraps everything, above the router, so marketing, the
        public rental flow and the tenant portal all get a language — all read
        by people who may not be signed in. */}
    <LocaleProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LocaleProvider>
  </React.StrictMode>,
);
